import {
  FontSizes,
  NeutralColors,
  Panel,
  PanelType,
  Persona,
  PersonaPresence,
  PersonaSize,
  Stack,
  divProperties,
  mergeStyleSets,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { IListaCuenta } from "../../../Interfaces/IUsuario";
import usuarioServicio from "../../../services/usuarioService";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import tipoDocumentoService from "../../../services/gestionDocumentos/tipoDocumentoService";

interface IPanelPanelEliminarTipo {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  documentoId: string;
}
export const PanelEliminarTipo = (props: IPanelPanelEliminarTipo) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [tipoDocumentoId, setTipoDocumentoId] = useState("");

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      validarForm();
      setTipoDocumentoId(props.documentoId);
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [tipoDocumentoId, props.isOpen]);

  const validarForm = () => {
    if (tipoDocumentoId == null) setDisableForm(true);
    if (tipoDocumentoId !== null) {
      if (tipoDocumentoId) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            Eliminar Tipo
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    [props.isOpen]
  );

  const _confirmar = () => {
    setIsSend(true);
    setDisableForm(true);
    setIsContenedor(true);
    tipoDocumentoService
      .deleteTipoDocumento(tipoDocumentoId)
      .then((res) => {
        if (res.status === 200) {
          setIsSend(false);

          if (res.data.confirmacion) {
            setIsSaccesfull(true);
            setMensaje(res.data.mensaje);
            props.onRenderTable();
            setTipoDocumentoId("");
          } else {
            setIsError(true);
            setMensajeError(res.data.mensaje);
          }
        }
      })
      .catch((err: Error) => {
        setIsSend(false);
        setIsError(true);
        setMensajeError("No se puedo Eliminar el Tipo");
      });
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Eliminar"
          texto2={"Cancelar"}
          disableButton={disableForm}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
        />
      </>
    ),
    [disableForm, props.documentoId]
  );

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setTipoDocumentoId("");
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
    >
      <>
        <br />
        {/* <pre>{JSON.stringify(tipoDocumentoId, null, 2)}</pre> */}

        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}

        <div hidden={isContenedor}>
          <Stack>
            <Stack.Item
              grow={3}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <span style={{ marginBottom: "15px", fontSize: "15px" }}>
                ¿Desea eliminar el Tipo?
              </span>

              <span>Una vez confirmado, esta acción no se podrá deshacer.</span>
            </Stack.Item>
          </Stack>
        </div>
        <br />
        <br />
      </>
    </Panel>
  );
};
